export default __webpack_public_path__ + "locales/subs.bua.json";